<a
  class="sidenav__link"
  [class.red]="red"
  [routerLink]="link.link">
  {{ link.label }}
</a>
